import { createApp } from 'vue'
import App from './App.vue'

import WeightConversion from './components/general/WeightConversion.vue'

//createApp(App).mount('#app')

import "bootstrap/dist/css/bootstrap.min.css"
import "bootstrap"

import i18n from './i18n'




const vueAppDiv = document.getElementById('canna-form-app');
if (vueAppDiv) {
   
    const app = createApp(App);

    //Set initial i18n locale based on the element's data-lang attribute
    i18n.global.locale.value = vueAppDiv.getAttribute('data-lang') || 'en';

    // Observe changes in the lang attribute
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === "attributes" && mutation.attributeName === "data-lang") {
                i18n.global.locale.value = mutation.target.getAttribute('data-lang');
            }
        });
    });

    // Start observing the element
    observer.observe(vueAppDiv, {
        attributes: true // Configure it to listen to attribute changes
    });

    app.use(i18n);
    app.mount('#canna-form-app');
}

//load the weight conversion form separately
const vueAppDiv2 = document.getElementById('weight-conversion-form');
if (vueAppDiv2) {

    const app2 = createApp(WeightConversion)

    //Set initial i18n locale based on the element's data-lang attribute
    i18n.global.locale.value = vueAppDiv2.getAttribute('data-lang') || 'en';

    // Observe changes in the lang attribute
    const observer = new MutationObserver(mutations => {
        mutations.forEach(mutation => {
            if (mutation.type === "attributes" && mutation.attributeName === "data-lang") {
                i18n.global.locale.value = mutation.target.getAttribute('data-lang');
            }
        });
    });

    // Start observing the element
    observer.observe(vueAppDiv2, {
        attributes: true // Configure it to listen to attribute changes
    });
 
    app2.use(i18n);
    
    app2.mount('#weight-conversion-form');
}